import axios from 'axios';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;


export const fetchData = (user) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_DATA' });
        axios.get(baseURL + 'forum', {
            params: {
                token: user.token,
                user_id: user.user_id,
                user_type: 'admin'
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'FETCH_DATA_SUCCESS', payload: response.data.data });
        }).catch(err => {
            dispatch({ type: 'FETCH_DATA_FAIL' });
            console.log(err);
        });
    };
};

export const userSelection = (user) => {
    return {
        type: 'USER_SELECTION',
        payload: user
    };
};

export const questionSelection = (question) => {
    return {
        type: 'QUESTION_SELECTION',
        payload: question
    };
};

export const textChange = (text) => {
    return {
        type: 'TEXT_CHANGE',
        payload: text
    };
};

export const broadcastMessageClear = () => {
    return {
        type: 'BROADCAST_MESSAGE_CLEAR'
    };
};

export const broadcastMessageChange = (broadcastText) => {
    return {
        type: 'BROADCAST_MESSAGE_CHANGE',
        payload: broadcastText
    };
};

export const messageTitleChange = (messageTitle) => {
    return {
        type: 'MESSAGE_TITLE_CHANGE',
        payload: messageTitle
    };
};

export const textClear = () => {
    return {
        type: 'TEXT_CLEAR'
    };
};

export const clearBroadcastText = () => {
    return {
        type: 'BROADCAST_TEXT_CLEAR'
    };
};

//Time
export const currentTime = (time) => {
    return {
        type: 'TIME',
        payload: time
    };
};

//Date
export const currentDate = (date) => {
    return {
        type: 'DATE',
        payload: date
    };
};

export const sendMessage = (user, question, id, message) => {
    return (dispatch) => {
        dispatch({ type: 'SEND_MESSAGE' });
        axios.post(baseURL + `forum/${id}`, {
            token: user.token,
            user_id: user.user_id,
            answer: message
        })
            .then((res) => {
                dispatch({ type: 'SEND_MESSAGE_SUCCESS', payload: res });
            })
            .catch((error) => {
                dispatch({ type: 'SEND_MESSAGE_FAIL' });
                console.log(error);
            });
    };
};

export const pushMessage = (user, messageTitle, broadcastText) => {
    return (dispatch) => {
        dispatch({ type: 'PUSH_MESSAGE' });
        axios.post(baseURL + 'broadcast/', {
            token: user.token,
            user_id: user.user_id,
            title: messageTitle,
            body: broadcastText
        })
            .then((res) => {
                dispatch({ type: 'PUSH_MESSAGE_SUCCESS', payload: res });
            })
            .catch((error) => {
                dispatch({ type: 'PUSH_MESSAGE_FAIL' });
                console.log(error);
            });
    };
};




// WEBPACK FOOTER //
// ./src/actions/ChatList/ChatListActions.js